import { clearFalsyValues } from '@speechki-frontend/shared/helpers/functions';

export function createTemplateRegexp(template, tokens) {
    let final = template;

    Object.entries(tokens).forEach(([token, { regexp, sort }], _, array) => {
        const insertAlter = sort < array.length;

        final = final.replace(`{${token}}`, `(?<${token}>${regexp})${insertAlter ? '|' : ''}`);
    });

    return final;
}

export function createTokenRegex(token) {
    if (token.type === 'select') {
        return token.values.map(escapeRegexSpecialChars).join('|');
    }

    if (token.type === 'number') {
        return '(\\d*\\.)?\\d+';
    }

    if (token.type === 'input') {
        return '\\.+';
    }
}

function escapeRegexSpecialChars(str) {
    const specialChars = ['+', '{', '}', 'd'];

    return specialChars.includes(str) ? `\\${str}` : str;
}

export function matchValue(value, template) {
    let regexp = new RegExp(template.regexp, 'g');
    let match = regexp.exec(value);

    if (!match) return;

    let newValue = value;
    const values = {};

    while (true) {
        const [group] = Object.entries(clearFalsyValues(match.groups));
        if (!group) break;

        const [tokenName, tokenValue] = group;

        const token = template.tokens[tokenName];

        values[tokenName] = typeValue(tokenValue, token);
        regexp = new RegExp(
            template.regexp.replace(
                `(?<${tokenName}>${token.regexp})${
                    token.sort < Object.keys(template.tokens).length ? '|' : ''
                }`,
                ''
            )
        );

        newValue = newValue.replace(tokenValue, '');
        match = regexp.exec(newValue);

        if (!match) break;
    }

    return values;
}

export function buildTemplate(values, template) {
    if (!values) return '';

    return Object.entries(values).reduce((acc, [token, value]) => {
        acc = acc.replace(`{${token}}`, value);

        return acc;
    }, template);
}

export function typeValue(value = '', { type = 'input', values = [] }) {
    if (type === 'number') {
        return Number(value);
    }

    if (!value && type === 'select' && values.length) {
        return values[0];
    }

    return value;
}

export function getDefaultValue({ type, default_value = '' }, value) {
    if (value) {
        return type === 'number' ? Number(value) : value;
    }

    if (type === 'number') return Number(default_value);

    return default_value;
}

export function getInitialValues(attributes, { attributes: nodeAttributes = null } = {}) {
    return Object.values(attributes).reduce((acc, attr) => {
        let defaultValue = getDefaultValue(attr);

        if (nodeAttributes) {
            const nodeValue = nodeAttributes[attr.name];

            if (nodeValue) {
                defaultValue = getDefaultValue(attr, nodeValue);
            }
        }

        acc[attr.name] = defaultValue;

        if (attr.optional && attr.optional[defaultValue]) {
            const optional = attr.optional[defaultValue];

            const values = getInitialValues(optional, nodeAttributes);

            acc = { ...acc, ...values };
        }

        return acc;
    }, {});
}
